import { Suspense } from 'react';

import LoadingScreen from 'components/LoadingScreen/LoadingScreen';
import SidebarWrapper from 'modules/SidebarWrapper/SidebarWrapper';

export const withSidebarWrapper = (contentContainerClass?: string) => (WrappedComponent: React.ComponentType) => {
  const WithSidebarWrapperComponent = () => (
    <SidebarWrapper contentContainerClass={contentContainerClass}>
      <Suspense fallback={<LoadingScreen />}>
        <WrappedComponent />
      </Suspense>
    </SidebarWrapper>
  );

  return WithSidebarWrapperComponent;
};

export default withSidebarWrapper;
